import { useState, useEffect } from 'react';
import sendData from 'redux/actions/sendData';
import { flatten, uniqBy, get, size } from 'global/lib/lodash';
import useRetrieveData from 'global/hooks/useRetrieveData';

export const useSupersets = (props) => {
  const { assessment } = props;

  const [state, setState] = useState({
    supersets: [],
  });

  const { data } = useRetrieveData(
    { url: '/supersets' },
    {
      build: ['supersets'],
      useCache: { reload: 20 },
      waitFor: !!assessment ? undefined : null,
    }
  );

  const scards = get(assessment, 'scorecards');
  const scorecardids = (scards || []).map((sc) => sc.id);
  const hasScorecards = !!size(scorecardids);

  const getData = async () => {
    let res;
    if (hasScorecards) {
      res = flatten(await Promise.all(scorecardids.map((sc) => sendData({ url: '/supersets' }, { normalize: { build: ['supersets'] }, params: { filter: { scorecard_id: sc } } }))));
    } else {
      res = data;
    }

    setState((s) => ({
      ...s,
      supersets: uniqBy(
        res.filter((f) => f),
        'id'
      ).map((ss) => ({ ...ss, id: ss.id.toString() })),
    }));
  };

  useEffect(() => {
    getData();
  }, [scards]);

  return state;
};
